<script setup>
import { zxcvbn, zxcvbnOptions } from "@zxcvbn-ts/core";
import * as zxcvbnCommonPackage from "@zxcvbn-ts/language-common";
import * as zxcvbnEnPackage from "@zxcvbn-ts/language-en";
import { twMerge } from "tailwind-merge";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

zxcvbnOptions.setOptions({
  translations: zxcvbnEnPackage.translations,
  graphs: zxcvbnCommonPackage.adjacencyGraphs,
  dictionary: {
    ...zxcvbnCommonPackage.dictionary,
    ...zxcvbnEnPackage.dictionary,
  },
});

const { t } = useI18n();

const props = defineProps({
  value: {
    type: String,
  },
});

const zxcvbnResult = computed(() => {
  return typeof props.value === "string" ? zxcvbn(props.value) : zxcvbn("");
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="flex items-center justify-between text-xs">
      <span>{{ t("fields.passwordStrength") }}:</span>
      <span
        :class="
          twMerge(
            zxcvbnResult.score === 0 && 'text-red-500',
            zxcvbnResult.score === 1 && 'text-red-400',
            zxcvbnResult.score === 2 && 'text-yellow-500',
            zxcvbnResult.score === 3 && 'text-green-400',
            zxcvbnResult.score === 4 && 'text-green-500',
          )
        "
      >
        {{ t(`common.passwordStrengths.${zxcvbnResult.score}`) }}
      </span>
    </div>
    <div class="h-1.5 overflow-hidden rounded-full bg-border">
      <div
        :class="
          twMerge(
            'h-full transition-all duration-300',
            zxcvbnResult.score === 0 && 'w-0 bg-red-500',
            zxcvbnResult.score === 1 && 'w-[calc(100%/4)] bg-red-400',
            zxcvbnResult.score === 2 && 'w-[calc(100%/4*2)] bg-yellow-500',
            zxcvbnResult.score === 3 && 'w-[calc(100%/4*3)] bg-green-400',
            zxcvbnResult.score === 4 && 'w-full bg-green-500',
          )
        "
      />
    </div>
  </div>
</template>
